module.exports = __webpack_public_path__ + "static/media/sidd_logo.fb770a5f.png";